import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { FILING_STATUS, FilingStatusBadge, money } from "./filingStatus";

export function FilingsTable({ filings, isAdmin, onOpen }) {
  return (
    <Table data-testid="filings-table">
      <TableHeader><TableRow>{isAdmin && <TableHead>Company</TableHead>}<TableHead>Filing</TableHead><TableHead>Period</TableHead><TableHead>Vehicles</TableHead><TableHead>Fees</TableHead><TableHead>Due</TableHead><TableHead>Status</TableHead><TableHead>Updated</TableHead></TableRow></TableHeader>
      <TableBody>
        {filings.length === 0 && <TableRow><TableCell colSpan={isAdmin ? 8 : 7} className="text-center py-10 text-slate-500">No filings yet.</TableCell></TableRow>}
        {filings.map((f) => {
          const s = FILING_STATUS[f.status];
          return (
            <TableRow key={f.id} className="cursor-pointer" onClick={() => onOpen(f)} data-testid={`filing-row-${f.id}`}>
              {isAdmin && <TableCell className="text-sm text-blue-700">{f.company}</TableCell>}
              <TableCell><div className="flex items-center gap-2"><span className={`w-1.5 h-6 rounded ${s.bar}`} /><b>{f.type_label}</b></div></TableCell>
              <TableCell className="font-mono text-sm">{f.period}</TableCell>
              <TableCell><Badge variant="outline" className="font-mono">{(f.vehicle_ids || []).length}</Badge></TableCell>
              <TableCell className="font-mono text-sm">{money((Number(f.gov_fee) || 0) + (Number(f.service_fee) || 0))}</TableCell>
              <TableCell className="font-mono text-xs">{f.due_date || "—"}</TableCell>
              <TableCell><FilingStatusBadge status={f.status} isAdmin={isAdmin} />{isAdmin && f.status === "awaiting_approval" && <span className="ml-1 text-xs font-mono text-amber-700" data-testid={`filing-waiting-${f.id}`}>waiting {Math.max(0, Math.floor((Date.now() - new Date(([...(f.history || [])].reverse().find((h) => h.action === "sent_for_approval") || {}).at || f.created_at)) / 86400000))}d{f.nudge_count ? ` · ${f.nudge_count} nudge${f.nudge_count > 1 ? "s" : ""}` : ""}</span>}</TableCell>
              <TableCell className="text-xs text-slate-500">{new Date(f.updated_at || f.created_at).toLocaleDateString()}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

